import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["de", "en"] as const,
  defaultLocale: "de",
  // URL strategy: /de/..., /en/... always prefixed — never silent root
  // redirects, Google indexes each locale as a distinct page.
  localePrefix: "always",
});
